<ng-container *ngIf="(user$ | async) as user; else unauthorized">
  <app-header></app-header>

  <div class="content-container">
    <div class="wrapper">
      <router-outlet></router-outlet>
    </div>
  </div>

</ng-container>

<ng-template #unauthorized>
  <app-auth></app-auth>
</ng-template>
